import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../redux/userSlice';
import { LogOut } from 'lucide-react';

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const user = useSelector(state => state.user.user);
  const currentLang = useSelector((state) => state.language.currentLanguage);
  const userId = user?.id;

  const translations = {
    "pt-AO": {
      signingOut: "Encerrando a sessão",
      wait: "aguarde um momento...",
      goodbye: "Até logo!",
      footer: "SISTEMA DE GESTÃO INTEGRADA"
    },
    "en-US": {
      signingOut: "Signing out",
      wait: "please wait a moment...",
      goodbye: "Goodbye!",
      footer: "INTEGRATED MANAGEMENT SYSTEM"
    },
    "zh-CN": {
      signingOut: "正在注销",
      wait: "请稍候...",
      goodbye: "再见！",
      footer: "综合管理系统"
    },
    "fr-FR": {
      signingOut: "Déconnexion en cours",
      wait: "veuillez patienter un instant...",
      goodbye: "À bientôt !",
      footer: "SYSTÈME DE GESTION INTÉGRÉ"
    },
    "ar-SA": {
      signingOut: "جارٍ تسجيل الخروج",
      wait: "يرجى الانتظار لحظة...",
      goodbye: "إلى اللقاء!",
      footer: "نظام الإدارة المتكامل"
    }
  };

  const t = translations[currentLang] || translations["pt-AO"];

  useEffect(() => {
    if (userId) {
      dispatch(logout(userId));
    } else {
      localStorage.clear();
    }

    const timer = setTimeout(() => navigate("/login"), 2500);
    return () => clearTimeout(timer);
  }, [dispatch, navigate, userId]);

  return (
    <div className="facturize-auth-page min-vh-100 d-flex align-items-center justify-content-center">
      <div className="vignette" />
      
      <div className="text-center position-relative" style={{ zIndex: 10 }}>
        {/* Loader Estilo Windows 10 adaptado */}
        <div className="win10-loader mb-4">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>

        <div className="animate__animated animate__fadeIn">
          <h2 className="fw-light mb-2 text-white" style={{ fontSize: '2.5rem', fontWeight: 300 }}>
            {t.signingOut}
          </h2>
          <p className="text-white-50 fs-5">
            {user?.nome ? `${user.nome}, ${t.wait}` : t.goodbye}
          </p>
        </div>
      </div>

      {/* Rodapé Facturize */}
      <div className="facturize-copyright">
        <LogOut size={14} className="me-2" />
        © {new Date().getFullYear()} FACTURIZE — {t.footer}
      </div>

      <style>{`
        .facturize-auth-page { 
          background: #000b1a; 
          font-family: 'Inter', 'Segoe UI', sans-serif; 
          position: relative; 
          overflow: hidden;
        }

        .vignette { 
          position: absolute; 
          width: 100%; 
          height: 100%; 
          background: radial-gradient(circle at center, rgba(0, 120, 212, 0.1) 0%, #000b1a 100%); 
        }

        .win10-loader {
          position: relative;
          width: 60px;
          height: 60px;
          margin: 0 auto;
        }

        .win10-loader .dot {
          position: absolute;
          width: 6px;
          height: 6px;
          background-color: #0078d4;
          border-radius: 50%;
          opacity: 0;
          animation: win-orbit 2.5s infinite;
          left: 27px;
        }

        .win10-loader .dot:nth-child(1) { animation-delay: 0.1s; }
        .win10-loader .dot:nth-child(2) { animation-delay: 0.2s; }
        .win10-loader .dot:nth-child(3) { animation-delay: 0.3s; }
        .win10-loader .dot:nth-child(4) { animation-delay: 0.4s; }
        .win10-loader .dot:nth-child(5) { animation-delay: 0.5s; }

        @keyframes win-orbit {
          0% { transform: rotate(225deg); opacity: 1; animation-timing-function: ease-out; }
          7% { transform: rotate(345deg); animation-timing-function: linear; }
          30% { transform: rotate(455deg); animation-timing-function: ease-in-out; }
          39% { transform: rotate(570deg); animation-timing-function: linear; }
          70% { transform: rotate(815deg); opacity: 1; animation-timing-function: ease-out; }
          75% { transform: rotate(945deg); animation-timing-function: ease-out; }
          76% { transform: rotate(945deg); opacity: 0; }
          100% { transform: rotate(945deg); opacity: 0; }
        }

        .facturize-copyright { 
          position: fixed; 
          bottom: 20px; 
          width: 100%; 
          text-align: center; 
          color: rgba(255, 255, 255, 0.4); 
          font-size: 10px; 
          letter-spacing: 1px; 
          text-transform: uppercase; 
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
    </div>
  );
};

export default Logout;